import { Mutex16li1l0asjv17 as Mutex } from './kotlinx-coroutines-core.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Enum3alwj03lh1n41 as Enum,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { Clientssjxb7gh2u6y as Client } from './Shared7Punches-infrastructure-network.mjs';
import { ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider } from './Shared7Punches-common-base.mjs';
import { ILogger102gekz4uf4a8 as ILogger } from './Shared7Punches-infrastructure-logging.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IFeatureFlagEvaluator, 'IFeatureFlagEvaluator');
initMetadataForInterface(IFeatureFlagOverrider, 'IFeatureFlagOverrider', VOID, VOID, VOID, [2, 1, 0]);
initMetadataForClass(FeatureFlagService, 'FeatureFlagService', VOID, VOID, [IFeatureFlagEvaluator, IFeatureFlagOverrider], [1, 2, 0]);
initMetadataForInterface(IFeatureFlagOverrideRepository, 'IFeatureFlagOverrideRepository', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForClass(FeatureFlagOverrideRepository, 'FeatureFlagOverrideRepository', VOID, VOID, [IFeatureFlagOverrideRepository], [0, 1, 2]);
initMetadataForInterface(IFeatureFlagRepository, 'IFeatureFlagRepository', VOID, VOID, VOID, [1]);
initMetadataForClass(FeatureFlagRepository, 'FeatureFlagRepository', VOID, VOID, [IFeatureFlagRepository], [1]);
initMetadataForInterface(IFeatureFlagRemoteSource, 'IFeatureFlagRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForClass(FeatureFlagRemoteSource, 'FeatureFlagRemoteSource', VOID, VOID, [IFeatureFlagRemoteSource], [1]);
initMetadataForInterface(IFeatureFlagOverrideLocalSource, 'IFeatureFlagOverrideLocalSource', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForCompanion(Companion);
initMetadataForClass(FeatureFlag, 'FeatureFlag', VOID, Enum);
initMetadataForCompanion(Companion_0);
initMetadataForClass(FeatureFlagOverrideLocalSource, 'FeatureFlagOverrideLocalSource', FeatureFlagOverrideLocalSource, VOID, [IFeatureFlagOverrideLocalSource], [0, 1, 2]);
//endregion
function FeatureFlagService(featureFlagRepository, featureFlagOverrideRepository, sessionDataProvider, logger) {
  this.p6q_1 = featureFlagRepository;
  this.q6q_1 = featureFlagOverrideRepository;
  this.r6q_1 = sessionDataProvider;
  this.s6q_1 = logger;
  this.t6q_1 = null;
  this.u6q_1 = Mutex();
}
function IFeatureFlagEvaluator() {
}
function IFeatureFlagOverrider() {
}
function FeatureFlagOverrideRepository(localSource) {
  this.v6q_1 = localSource;
}
function FeatureFlagRepository(remoteSource) {
  this.w6q_1 = remoteSource;
}
function FeatureFlagRemoteSource(apiClient) {
  this.x6q_1 = apiClient;
}
function IFeatureFlagOverrideLocalSource() {
}
function IFeatureFlagRemoteSource() {
}
function get_featureFlagModule() {
  _init_properties_FeatureFlagModule_kt__6angpw();
  return featureFlagModule;
}
var featureFlagModule;
function featureFlagModule$lambda($this$module) {
  _init_properties_FeatureFlagModule_kt__6angpw();
  $this$module.o1c([get_featureFlagPlatformModule()]);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = featureFlagModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IFeatureFlagOverrideRepository), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = featureFlagModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IFeatureFlagRepository), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = featureFlagModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IFeatureFlagRemoteSource), null, tmp2_1, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = featureFlagModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(FeatureFlagService), null, definition, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = featureFlagModule$lambda$lambda_3;
  var scopeQualifier_3 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Singleton_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(IFeatureFlagEvaluator), null, definition_0, kind_3, secondaryTypes_3);
  var factory_3 = new SingleInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_3);
  }
  new KoinDefinition($this$module, factory_3);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = featureFlagModule$lambda$lambda_4;
  var scopeQualifier_4 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Singleton_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(IFeatureFlagOverrider), null, definition_1, kind_4, secondaryTypes_4);
  var factory_4 = new SingleInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_4);
  }
  new KoinDefinition($this$module, factory_4);
  return Unit_instance;
}
function featureFlagModule$lambda$lambda($this$factory, it) {
  _init_properties_FeatureFlagModule_kt__6angpw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(IFeatureFlagOverrideLocalSource), null, null);
  return new FeatureFlagOverrideRepository(tmp$ret$0);
}
function featureFlagModule$lambda$lambda_0($this$factory, it) {
  _init_properties_FeatureFlagModule_kt__6angpw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(IFeatureFlagRemoteSource), null, null);
  return new FeatureFlagRepository(tmp$ret$0);
}
function featureFlagModule$lambda$lambda_1($this$factory, it) {
  _init_properties_FeatureFlagModule_kt__6angpw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new FeatureFlagRemoteSource(tmp$ret$0);
}
function featureFlagModule$lambda$lambda_2($this$single, it) {
  _init_properties_FeatureFlagModule_kt__6angpw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IFeatureFlagRepository), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(IFeatureFlagOverrideRepository), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(ILogger), null, null);
  return new FeatureFlagService(tmp, tmp_0, tmp_1, tmp$ret$3);
}
function featureFlagModule$lambda$lambda_3($this$single, it) {
  _init_properties_FeatureFlagModule_kt__6angpw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  return $this$single.q1d(getKClass(FeatureFlagService), null, null);
}
function featureFlagModule$lambda$lambda_4($this$single, it) {
  _init_properties_FeatureFlagModule_kt__6angpw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  return $this$single.q1d(getKClass(FeatureFlagService), null, null);
}
var properties_initialized_FeatureFlagModule_kt_yziltu;
function _init_properties_FeatureFlagModule_kt__6angpw() {
  if (!properties_initialized_FeatureFlagModule_kt_yziltu) {
    properties_initialized_FeatureFlagModule_kt_yziltu = true;
    featureFlagModule = module_0(VOID, featureFlagModule$lambda);
  }
}
function IFeatureFlagOverrideRepository() {
}
function IFeatureFlagRepository() {
}
var FeatureFlag_ANDROID_ACCOUNT_CANCELLATION_instance;
var FeatureFlag_IOS_ACCOUNT_DELETION_instance;
var FeatureFlag_MOBILE_SHIFT_COMPOSITE_ACCESSOR_IN_KMP_instance;
var FeatureFlag_MOBILE_USER_REST_ACCESS_instance;
var FeatureFlag_EMPLOYEE_SIMPLE_PASSWORD_instance;
var FeatureFlag_MOBILE_CASBIN_PHASE_ONE_instance;
var FeatureFlag_MOBILE_CASBIN_PHASE_TWO_instance;
var FeatureFlag_TRAINING_instance;
var FeatureFlag_MOBILE_CLAIR_SDK_INTEGRATION_instance;
var FeatureFlag_MOBILE_KNOCK_TO_JOIN_2026_instance;
var FeatureFlag_KNOCK_TO_JOIN_instance;
var FeatureFlag_MOBILE_OT_RISK_SUMMARY_instance;
var FeatureFlag_TRAINING_GENERAL_AVAILABILITY_instance;
var FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_instance;
var FeatureFlag_MOBILE_MULTI_QUESTION_ATTESTATION_instance;
function Companion() {
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var FeatureFlag_entriesInitialized;
function FeatureFlag_initEntries() {
  if (FeatureFlag_entriesInitialized)
    return Unit_instance;
  FeatureFlag_entriesInitialized = true;
  FeatureFlag_ANDROID_ACCOUNT_CANCELLATION_instance = new FeatureFlag('ANDROID_ACCOUNT_CANCELLATION', 0, 'android_account_cancellation');
  FeatureFlag_IOS_ACCOUNT_DELETION_instance = new FeatureFlag('IOS_ACCOUNT_DELETION', 1, 'mobile_account_deletion');
  FeatureFlag_MOBILE_SHIFT_COMPOSITE_ACCESSOR_IN_KMP_instance = new FeatureFlag('MOBILE_SHIFT_COMPOSITE_ACCESSOR_IN_KMP', 2, 'mobile_shift_composite_accessor_in_kmp');
  FeatureFlag_MOBILE_USER_REST_ACCESS_instance = new FeatureFlag('MOBILE_USER_REST_ACCESS', 3, 'mobile_user_rest_access');
  FeatureFlag_EMPLOYEE_SIMPLE_PASSWORD_instance = new FeatureFlag('EMPLOYEE_SIMPLE_PASSWORD', 4, 'employee_simple_password');
  FeatureFlag_MOBILE_CASBIN_PHASE_ONE_instance = new FeatureFlag('MOBILE_CASBIN_PHASE_ONE', 5, 'mobile_casbin_phase_one');
  FeatureFlag_MOBILE_CASBIN_PHASE_TWO_instance = new FeatureFlag('MOBILE_CASBIN_PHASE_TWO', 6, 'mobile_casbin_phase_two');
  FeatureFlag_TRAINING_instance = new FeatureFlag('TRAINING', 7, 'training');
  FeatureFlag_MOBILE_CLAIR_SDK_INTEGRATION_instance = new FeatureFlag('MOBILE_CLAIR_SDK_INTEGRATION', 8, 'mobile_clair_sdk_integration');
  FeatureFlag_MOBILE_KNOCK_TO_JOIN_2026_instance = new FeatureFlag('MOBILE_KNOCK_TO_JOIN_2026', 9, 'mobile_knock_to_join_2026');
  FeatureFlag_KNOCK_TO_JOIN_instance = new FeatureFlag('KNOCK_TO_JOIN', 10, 'knock_to_join');
  FeatureFlag_MOBILE_OT_RISK_SUMMARY_instance = new FeatureFlag('MOBILE_OT_RISK_SUMMARY', 11, 'mobile_ot_risk_summary');
  FeatureFlag_TRAINING_GENERAL_AVAILABILITY_instance = new FeatureFlag('TRAINING_GENERAL_AVAILABILITY', 12, 'training_general_availability');
  FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_instance = new FeatureFlag('MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS', 13, 'mobile_training_manager_task_sign_offs');
  FeatureFlag_MOBILE_MULTI_QUESTION_ATTESTATION_instance = new FeatureFlag('MOBILE_MULTI_QUESTION_ATTESTATION', 14, 'mobile_multi_question_attestation');
}
function FeatureFlag(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.a6r_1 = value;
}
function FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_getInstance() {
  FeatureFlag_initEntries();
  return FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_instance;
}
function createFeatureFlagOverrideLocalSource(logger) {
  return Companion_instance_0.b6r(logger);
}
function Companion_0() {
}
protoOf(Companion_0).b6r = function (logger) {
  return new FeatureFlagOverrideLocalSource();
};
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function FeatureFlagOverrideLocalSource() {
}
function get_featureFlagPlatformModule() {
  _init_properties_FeatureFlagPlatformModule_kt__j6j15d();
  return featureFlagPlatformModule;
}
var featureFlagPlatformModule;
function featureFlagPlatformModule$lambda($this$module) {
  _init_properties_FeatureFlagPlatformModule_kt__j6j15d();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = featureFlagPlatformModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IFeatureFlagOverrideLocalSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  return Unit_instance;
}
function featureFlagPlatformModule$lambda$lambda($this$factory, it) {
  _init_properties_FeatureFlagPlatformModule_kt__j6j15d();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(ILogger), null, null);
  return createFeatureFlagOverrideLocalSource(tmp$ret$0);
}
var properties_initialized_FeatureFlagPlatformModule_kt_dao4pb;
function _init_properties_FeatureFlagPlatformModule_kt__j6j15d() {
  if (!properties_initialized_FeatureFlagPlatformModule_kt_dao4pb) {
    properties_initialized_FeatureFlagPlatformModule_kt_dao4pb = true;
    featureFlagPlatformModule = module_0(VOID, featureFlagPlatformModule$lambda);
  }
}
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  get_featureFlagModule as get_featureFlagModule2olng1e88stui,
  FeatureFlagService as FeatureFlagServiceoy7s0oetsvxe,
  IFeatureFlagEvaluator as IFeatureFlagEvaluatorscidb4c0cp4,
  IFeatureFlagOverrider as IFeatureFlagOverrider2e91dbyu864rc,
  FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_getInstance as FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_getInstance1rlpby9q90frf,
};
//endregion

